import axios from "axios";
import { CPKeyPersonDetailsType } from "../pages/types/KeyPersonDetailsType";

export const CPCreateKeyPerson = (
  CPKeyPersonsDetails: CPKeyPersonDetailsType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.customer_key_person`,
      {
        params: {
          context: {},
          data: CPKeyPersonsDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
